import './App.css';
import Navbar from './componenets/Navbar/Navbar';
import Home from './componenets/Home/Home';
import About from './componenets/About/About';
import Footer from './componenets/Footer/Footer';
import {Routes, Route} from 'react-router-dom'
import { commerce } from './utils/commerce'
import { useEffect, useState } from 'react';


function App() {

  const [cart, setCart] = useState({})

  const addToCart = async (productId, quantity) => {
    const {cart} = await commerce.cart.add(productId, quantity)

    setCart(cart)
  }

  const updateCartQty = async (productId, quantity) => {
    const {cart} = await commerce.cart.update(productId, {quantity})

    setCart(cart)
  }
  
  const removeFromCart = async (productId) => {
    const {cart} = await commerce.cart.remove(productId)

    setCart(cart)
  }

  const fetchCart = async () => {
    setCart(await commerce.cart.retrieve())
  }

  useEffect(() =>{ 
    fetchCart()
  }, [setCart])

  if(cart == null) {
    return 'Loading...'
  }

  return (
    <div className="App">
      <Navbar updateCartQty={updateCartQty} 
              removeFromCart={removeFromCart} 
              cartTotal={cart.total_items} 
              cart={cart} 
      />
      <Routes>
        <Route path='/' exact element={<Home addToCart={addToCart}  />} />
        <Route path='/about' exact element={<About />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
